import {
  AlertCircleIcon,
  NotEqualSignIcon
} from "@hugeicons-pro/core-stroke-rounded";
import { HugeiconsIcon } from "@hugeicons/react";
import { cx } from "shared/utils";
import { NameMismatch } from "../../../types/verified/common";

export const NameMismatchAlert = ({
  nameMismatch,
  className
}: {
  nameMismatch: NameMismatch;
  className?: string;
}) => (
  <div
    className={cx(
      "flex items-start gap-3 rounded-lg border border-alpha-100 bg-danger-50 p-4",
      className
    )}
  >
    <HugeiconsIcon
      icon={AlertCircleIcon}
      size={20}
      className="mt-0.5 shrink-0 text-danger-500"
    />
    <div className="flex flex-col gap-1">
      <p className="text-sm font-bold text-content-1000">
        Name mismatch in the document
      </p>
      <div className="flex flex-wrap items-center gap-2 text-sm text-content-400">
        <span>Name in the document: {nameMismatch.name_in_document}</span>
        <HugeiconsIcon
          icon={NotEqualSignIcon}
          size={16}
          strokeWidth={2}
          className="shrink-0 text-content-400"
        />
        <span>Applicant name: {nameMismatch.applicant_name}</span>
      </div>
    </div>
  </div>
);
